import React from 'react'

import { PageHeaderProps } from './header.types'

const SettingsHeader = (props: PageHeaderProps) => {
  return (
    <div className='mt-0 whitebg d-flex justify-content-between align-items-start align-items-sm-center flex-wrap px-0'>
      <div className='d-flex align-items-center py-1'>
        {props?.name && (
          <div
            aria-describedby='settingstitle'
            className='d-flex align-items-center poppins-medium text-color7 text-nowrap text-uppercase'
            id='settingstitle'
            tabIndex={0}


          >
            {props?.icon && <span className={props.icon}></span>}
            <h2

              className='font-16 poppins-semibold title-color2'

            >
              {props.name}
            </h2>
            {props?.count && (
              <span

                className='badge bgcolor-primary border-radius3 px-2 py-1 font-12 whitetext poppins-semibold ms-2'

              >
                {' '}
                {props?.count}
              </span>
            )}
          </div>
        )}
        {props?.toolTip && props.toolTip}
      </div>
      <div className='d-flex flex-column flex-sm-row align-items-md-center w-100 maxfitcontent-sm ms-sm-auto'>
        <div className='d-flex flex-wrap flex-column flex-sm-row justify-content-sm-end gap-2'>
          {props.extras && props.extras}
        </div>
      </div>
    </div>
  )
}
export { SettingsHeader }
